import { Link } from 'react-router-dom';
import { GameLayout } from './GameLayout';
import type { GameMeta } from '../components/GameCard';

const GAMES: GameMeta[] = [
  {
    num: '№ 01',
    title: 'Мафия',
    desc: 'Дон, шериф, мирные. Кто-то врёт, кто-то умрёт. Классика, без которой не обходится ни один вечер.',
    info: '8–14 игроков · 30 мин',
    to: '/play/mafia',
    badge: 'В топе',
  },
  {
    num: '№ 02',
    title: 'Заяц',
    desc: 'Секретное слово знают все, кроме одного. Ассоциации, блеф и голосование.',
    info: '3–12 · 20 мин',
    to: '/play/zayac',
    badge: 'New',
  },
  { num: '№ 03', title: 'Alias', desc: 'Объясни слово — не назвав его. Команды на скорость.', info: '4+ · 20 мин', to: '/play/alias' },
  { num: '№ 04', title: 'Крокодил', desc: 'Покажи без слов. Угадай за 60 секунд.', info: '4+ · 25 мин', to: '/play/crocodile' },
  { num: '№ 05', title: 'Бункер', desc: 'Кого пустим внутрь, когда наверху апокалипсис?', info: '6–12 · 45 мин', to: '/play/bunker' },
  { num: '№ 06', title: 'Имаджинариум', desc: 'Ассоциативные карточки. Странно и красиво.', info: '4–7 · 30 мин', to: '/play/imaginarium' },
];

export function GameSelector() {
  return (
    <GameLayout>
      <SelectorStyles />
      <span className="label">/ Каталог · выбери игру</span>
      <h1 className="sel-title">
        Во что <span className="accent-word">играем</span>?
      </h1>
      <p className="sel-lede">
        Выбирай игру из списка — и создавай комнату за минуту. Уже работают Мафия, Alias, Заяц и Бункер.
      </p>

      <div className="sel-list">
        <div className="sel-head">
          <span className="label">Доступно игр: {GAMES.length}</span>
          <span className="mono" style={{ fontSize: 11, color: 'var(--ink-faint)', letterSpacing: '0.14em', textTransform: 'uppercase' }}>
            Сортировка: популярные
          </span>
        </div>
        {GAMES.map((g) => (
          <Link to={g.to} key={g.num} className="sel-row">
            <span className="sel-num">{g.num}</span>
            <div className="sel-body">
              <div className="sel-name-row">
                <h3>{g.title}</h3>
                {g.badge ? <span className="sel-badge">{g.badge}</span> : null}
              </div>
              <div className="sel-desc">{g.desc}</div>
            </div>
            <div className="sel-meta">
              <span className="sel-info">{g.info}</span>
              <span className="sel-go">Играть →</span>
            </div>
            <div className="sel-hover" />
          </Link>
        ))}
      </div>

      <div className="sel-footer">
        <span className="mono" style={{ fontSize: 11, color: 'var(--ink-faint)', letterSpacing: '0.14em', textTransform: 'uppercase' }}>
          Ещё 23 игры в разработке
        </span>
      </div>
    </GameLayout>
  );
}

function SelectorStyles() {
  return (
    <style>{`
      .sel-title { font-family: 'Oswald', sans-serif; font-weight: 600; font-size: 88px; line-height: 1.02; letter-spacing: -.015em; margin: 12px 0 0; }
      .sel-lede { max-width: 560px; font-size: 17px; line-height: 1.55; color: var(--ink-dim); margin: 24px 0 56px; }

      .sel-head { display: flex; justify-content: space-between; align-items: baseline; padding-bottom: 14px; border-bottom: 1px solid var(--line-strong); }
      .sel-list { display: flex; flex-direction: column; }

      .sel-row { position: relative; display: grid; grid-template-columns: 64px 1fr 220px; align-items: center; gap: 24px;
        padding: 26px 0; border-bottom: 1px solid var(--line); cursor: pointer; text-decoration: none; color: inherit;
        transition: background .2s, padding .2s; }
      .sel-row:hover { background: var(--bg2); padding-left: 16px; padding-right: 16px; }
      .sel-num { font-family: 'JetBrains Mono', monospace; font-size: 12px; color: var(--ink-faint); letter-spacing: .16em; align-self: flex-start; padding-top: 6px; }
      .sel-body { min-width: 0; }
      .sel-name-row { display: flex; align-items: center; gap: 12px; margin-bottom: 8px; }
      .sel-name-row h3 { font-family: 'Oswald', sans-serif; font-weight: 600; font-size: 34px; line-height: 1; letter-spacing: -.005em; margin: 0; }
      .sel-badge { font-family: 'JetBrains Mono', monospace; font-size: 10px; background: var(--accent); color: var(--accent-ink); padding: 4px 8px; letter-spacing: .12em; border-radius: 3px; text-transform: uppercase; }
      .sel-desc { font-size: 14px; color: var(--ink-dim); line-height: 1.5; max-width: 560px; }

      .sel-meta { display: flex; flex-direction: column; align-items: flex-end; gap: 8px; }
      .sel-info { font-family: 'JetBrains Mono', monospace; font-size: 11px; color: var(--ink-dim); letter-spacing: .08em; white-space: nowrap; }
      .sel-go { font-family: 'JetBrains Mono', monospace; font-size: 11px; color: var(--ink); letter-spacing: .12em; white-space: nowrap; }

      .sel-hover { position: absolute; bottom: -1px; left: 0; height: 2px; width: 0; background: var(--accent); transition: width .35s cubic-bezier(.2,.8,.2,1); }
      .sel-row:hover .sel-hover { width: 100%; }

      .sel-footer { margin-top: 40px; }

      @media (max-width: 900px) { .sel-title { font-size: 56px; } }
      @media (max-width: 760px) {
        .sel-row { grid-template-columns: 44px 1fr; row-gap: 6px; }
        .sel-meta { grid-column: 2; flex-direction: row; align-items: center; justify-content: flex-start; gap: 16px; }
        .sel-name-row h3 { font-size: 28px; }
      }
    `}</style>
  );
}
